<template>
  <a
    v-bind:href="href"
    v-bind:class="{ active: isActive }"
	v-on:click="reloadVideo()"
  >
    <slot></slot>
  </a>
</template>

<script>
  import routes from '../routes'

  export default {
    props: {
      href: String,
      required: true
    },
	methods: {
		reloadVideo() {
			console.log("video clicked")
			setTimeout(
			window.pageLoaded,50);
			
		}
	},
    computed: {
      isActive () {
        return this.href === window.location.pathname
      }
    }
  }
</script>

<style scoped>
  .active {
    color: black;
  }
</style>



// WEBPACK FOOTER //
// VLink.vue?d8a67b8a